import { contentGet } from '../../email-activity/content-api'
import { viewerTimeZone } from '../../date/local-time'

// GET /api/ddd/audit/insights/:panel (phase 5 Task 10): one bounded
// aggregate for one Insights panel, read with the timeline's own query
// parameters (scope, filters) through the same gate. panel is one of
// calendar | punch | mix | launches | changed | apps | sessions | network.
// Without from/to each panel reads its own default window. Hours and days
// are the reader's (tz=); every answer names its zone (timeZone).
// Throws the response on refusal ({ status, data: { code, message } }); a
// slow read is 503 audit.too_slow.
export const getInsight = (panel, params) => contentGet(`audit/insights/${panel}`, { ...(params || {}), tz: viewerTimeZone() })
